module.exports = __webpack_public_path__ + "static/img/bg4.1b6513cc.png";